import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Page } from 'signoxe/components';
import Box from '../../layout/Box';
import Button from '../../widgets/Button';

import PermissionModal from '../../widgets/PermissionModal';

import { Icon } from '../../widgets';
 import { GrapejsEditor } from 'signoxe/components';
import { Link } from 'react-router-dom';

import {
  fetchCustomTemplates, setPageTitle, uploadAsset
} from 'signoxe/actions';

import {
  getUsers, isFetching, getCustomTemplates
} from 'signoxe/selectors';

// import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';

// import './styles.scss';

import _ from 'lodash';

class TemplatePreview extends React.Component {
  checkImage(){
    const thumbnail = this.props.template.thumbnail;
    console.log(thumbnail)
    if (thumbnail && thumbnail.length && thumbnail.startsWith('http')){
      return thumbnail
    }

    return 'https://images.unsplash.com/photo-1485217988980-11786ced9454?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80'
  }

  render(){
    const { history } = this.props;

    const style = {
      backgroundImage: `url(${this.checkImage()})`
    }

    return (
    <div 
      className='preview-box' 
      onClick={()=>history.push(`/template-edit?template=${this.props.template.id}`)} 
      style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
        <div style={style} className='preview-overlay'></div>
      <span className='preview-text'>{this.props.template.name}</span>
    </div>
    )
  }
}

class HtmlPage extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      selected: null,
      html: ''
    }
  }

  componentDidMount(){
    this.props.fetchCustomTemplates()
    // this.props.setPageTitle('Add Zip asset')
  }

  handleContentChange(){
    console.log('Changed grapejs editor')
  }

  handleTemplateChange(e){
    const selected = e.target.selectedOptions[0].value;
    const data = this.props.templates[selected]

    const html = data ? data.template : ''

    this.setState({html, selected})
  }

  render() {
    const { templates } = this.props;

    console.log("templates", templates)

    const { selected } = this.state;

    return (
     <Box justifyContent="center" wrap className="template-list">
          {templates.map(template =>
            <TemplatePreview history={this.props.history} key={template.id} template={template} />
          )}
          {/* {templates.map(template =>
            <TemplatePreview history={this.props.history} key={template.id} template={template} />
          )} */}
      </Box>
    );
  }
}

export default connect((state, props) => {
    return {
        templates: getCustomTemplates(state)
        // isFetching: isFetching(state)
    };
  },
  {
    fetchCustomTemplates, setPageTitle,
    uploadAsset
  },
)(HtmlPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Html.js